/**
 * Symplifi   API
 * Symplifi backend API description 
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ItemDto } from './item-dto';


export interface CreatePaymentRequestRequest { 
    amount: number;
    amountCredit: number;
    amountCurrency: CreatePaymentRequestRequest.AmountCurrencyEnum;
    amountInSecondaryCurrency: number;
    amountInSecondaryCurrencyCurrency: CreatePaymentRequestRequest.AmountInSecondaryCurrencyCurrencyEnum;
    type: CreatePaymentRequestRequest.TypeEnum;
    paymentMethod: CreatePaymentRequestRequest.PaymentMethodEnum;
    durationInDays: number;
    termsAccepted: boolean;
    supplierName: string;
    supplierId: string;
    items: Array<ItemDto>;
}
export namespace CreatePaymentRequestRequest {
    export type AmountCurrencyEnum = 'USD' | 'KES' | 'KES_SUPPLIER' | 'KES_OTHER' | 'RWF' | 'AED' | 'CNY';
    export const AmountCurrencyEnum = {
        Usd: 'USD' as AmountCurrencyEnum,
        Kes: 'KES' as AmountCurrencyEnum,
        KesSupplier: 'KES_SUPPLIER' as AmountCurrencyEnum,
        KesOther: 'KES_OTHER' as AmountCurrencyEnum,
        Rwf: 'RWF' as AmountCurrencyEnum,
        Aed: 'AED' as AmountCurrencyEnum,
        Cny: 'CNY' as AmountCurrencyEnum
    };
    export type AmountInSecondaryCurrencyCurrencyEnum = 'USD' | 'KES' | 'KES_SUPPLIER' | 'KES_OTHER' | 'RWF' | 'AED' | 'CNY';
    export const AmountInSecondaryCurrencyCurrencyEnum = {
        Usd: 'USD' as AmountInSecondaryCurrencyCurrencyEnum,
        Kes: 'KES' as AmountInSecondaryCurrencyCurrencyEnum,
        KesSupplier: 'KES_SUPPLIER' as AmountInSecondaryCurrencyCurrencyEnum,
        KesOther: 'KES_OTHER' as AmountInSecondaryCurrencyCurrencyEnum,
        Rwf: 'RWF' as AmountInSecondaryCurrencyCurrencyEnum,
        Aed: 'AED' as AmountInSecondaryCurrencyCurrencyEnum,
        Cny: 'CNY' as AmountInSecondaryCurrencyCurrencyEnum
    };
    export type TypeEnum = 'PAY_NOW' | 'FLEX_PAY';
    export const TypeEnum = {
        PayNow: 'PAY_NOW' as TypeEnum,
        FlexPay: 'FLEX_PAY' as TypeEnum
    };
    export type PaymentMethodEnum = 'TRANSFER' | 'ON_DELIVERY' | 'CREDIT' | 'NOT_AVAILABLE';
    export const PaymentMethodEnum = {
        Transfer: 'TRANSFER' as PaymentMethodEnum,
        OnDelivery: 'ON_DELIVERY' as PaymentMethodEnum,
        Credit: 'CREDIT' as PaymentMethodEnum,
        NotAvailable: 'NOT_AVAILABLE' as PaymentMethodEnum
    };
}


